import React, { useEffect, useRef, useState } from "react";
import { Badge, Collapse, Form, ListGroup } from "react-bootstrap";
import { CiMedicalClipboard, CiMenuKebab } from "react-icons/ci";
import { IoIosCloseCircleOutline, IoIosStats } from "react-icons/io";
import { useParams } from "react-router-dom";
import { FaHistory, FaLongArrowAltRight, FaRandom, FaRegCheckCircle, FaRegPlusSquare } from "react-icons/fa";
import { MdOutlineAssignmentTurnedIn, MdOutlineAutoDelete, MdRepeatOne, MdTimeline } from "react-icons/md";
import { FaArrowsSpin, FaCircleCheck, FaCircleXmark, FaRegCircleXmark } from "react-icons/fa6";
import { RiChatHistoryLine } from "react-icons/ri";
import { FiActivity, FiSend } from "react-icons/fi";
import { BiDetail } from "react-icons/bi";
import { BsBarChartLineFill } from "react-icons/bs";
import { FaEdit, FaTrash } from "react-icons/fa";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { studySiteDataEntryServices } from "../../../../APIServices/studySiteDataEntryServices";
import { studySubjectManagementServices } from "../../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import ManIconHighlighted from "../../../../img/man-highlighted.png";
import ManIconInitiate from "../../../../img/man-initiate.png";
import ManIconRed from "../../../../img/manred.png";
import WomanIconHighlighted from "../../../../img/woman-avatar-highlighted.png";
import WomanIconInitiate from "../../../../img/woman-avatar.png";
import WomanIconRed from "../../../../img/womanred.png";
import UnknownIconHighlighted from "../../../../img/UnknownHighlight.png";
import UnknownIconInitiate from "../../../../img/unknown.png";
import UnknownIconRed from "../../../../img/unknownred.png";
import AddNewSubject from "./SubjectData/AddNewSubject";
import UpdateSubject from "./SubjectData/UpdateSubject";
import DeletedSubject from "./SubjectData/DeletedSubject";
import DeletedRepeatEvent from "./SubjectData/DeletedRepeatEvent";
import UseToggle from "../../../../Hooks/UseToggle";
import Swal from "sweetalert2";
import ViewSubjectGraph from "./SubjectData/ViewSubjectGraph";
import ViewSubjectActivity from "./SubjectData/ViewSubjectActivity";
import ViewSubjectHistory from "./SubjectData/ViewSubjectHistory";
import SplitPane from "react-split-pane";
import ViewSubjectDetails from "./SubjectData/ViewSubjectDetails";
import ViewSiteSubjectGraph from "./SubjectData/ViewSiteSubjectGraph";
import ViewSubjectMilestone from "./SubjectData/ViewSubjectMilestone";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";
import AssignRandomizationSubject from "./SubjectData/AssignRandomizationSubject";
import MedicalReviewSetting from "./SubjectData/MedicalReviewSetting";
import SendForMedicalReview from "./SubjectData/SendForMedicalReview";
import { studySubjectPrincipleInvestigatorServices } from "../../../../APIServices/studySubjectPrincipleInvestigatorServices";
import AssignFormSDVReviewer from "./SubjectData/AssignFormSDVReviewer";
import Eligiblity from "./Eligiblity";
import Discontinue from "./Discontinue";
import Completion from "./Completion";
import ScreeningFail from "./ScreeningFail";
import { handleResponse } from "../../../../APIHelpers/Responses";
import ReassignRandomizationSubject from "./SubjectData/ReassignRandomizationSubject";
import ViewSiteHistory from "./SubjectData/ViewSiteHistory";

const SiteSubjectEventLists = ({ handleAddNewTab, tableRef, onMouseDown, activeTabName }) => {
  const [openEvents, setOpenEvents] = useState("");
  const [openTimePointEvents, setOpenTimePointEvents] = useState("");
  const [siteId, setSiteId] = useState("no");
  const [siteName, setSiteName] = useState("");
  const [subjectSettings, setSubjectSettings] = useState("");
  const [schemaId, setSchemaId] = useState("no");
  const [subjectName, setSubjectName] = useState("");
  const [subjectVoid, setSubjectVoid] = useState(false);
  const [subjectDetails, setSubjecDetails] = useState("");
  const [eventName, setEventName] = useState("");
  const [eventId, setEventId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [subjectIdForUpdate, setSubjectIdForUpdate] = useState("");
  const [subjectSiteLoader, setSubjectSiteLoader] = useState(false);
  const [deletedSubjectLoader, setDeletedSubjectLoader] = useState(false);
  const [deletedRepeatEventLoader, setDeletedRepeatEventLoader] = useState(false);
  const [deletedRepeatEventList, setDeletedRepeatEventList] = useState([]);
  const [specialFormStatus, setSpecialFormStatus] = useState("");
  const [eventLoading, setEventLoading] = useState(false);
  const [eventTimepointLoading, setEventTimepointLoading] = useState(false);
  const [siteSubjectList, setSiteSubjectList] = useState([]);
  const [siteEventList, setSiteEventList] = useState([]);
  const [siteEventTimePointList, setSiteEventTimePointList] = useState([]);
  const [subjectDeletedRows, setSubjectDeletedRows] = useState([]);
  const [assignedUser, setAssignedUser] = useState([]);
  const [subjectDeletedRowsCount, setSubjectDeletedRowsCount] = useState(0);
  const [openAction, setOpenAction] = useState("");
  const { studyId } = useParams();
  const { toggle, setToggle, toggle1, setToggle1, toggle2, setToggle2, toggle3, setToggle3, toggle4, setToggle4, toggle5, setToggle5, toggle6, setToggle6, toggle7, setToggle7, toggle8, setToggle8, toggle9, setToggle9, toggle10, setToggle10, toggle11, setToggle11, toggle12, setToggle12, toggle13, setToggle13, toggle14, setToggle14, toggle15, setToggle15, toggle16, setToggle16, toggle17, setToggle17, toggle18, setToggle18, toggle19, setToggle19 } = UseToggle();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const categoryRole = JSON.parse(localStorage.getItem("role"));
  const studyPermission = JSON.parse(localStorage.getItem("studyPermissionData"));
  // Repeated event delete and deleted-history are only for DBP, Live and QC modes, never SDV
  const canDeleteRepeatEvent = ["DBP Mode", "Live Mode", "QC Mode"].includes(StudyMode);
  const [subjectUpdateLoader, setSubjectUpdateLoader] = useState(false);
  const [subjectStatusLoader, setSubjectStatusLoader] = useState(false);
  const [reason, setReason] = useState("");
  const [category, setCategory] = useState("");
  const [remark, setRemark] = useState("");
  const [completionDate, setCompletionDate] = useState("");
  const AppsRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppsRef.current && !AppsRef.current.contains(event.target)) {
        setOpenAction(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const handleDragEnd = async (result) => {
    if (!result.destination) return;
    const { source, destination } = result;
    const siteId = result?.source?.droppableId;
    let subjectResult = [];
    setSiteSubjectList((prevList) => {
      return prevList.map((site) => {
        if (site.siteId === siteId) {
          const updatedSubjects = Array.from(site.totalSubject);
          const [movedItem] = updatedSubjects.splice(source.index, 1);
          updatedSubjects.splice(destination.index, 0, movedItem);
          subjectResult = updatedSubjects;
          return {
            ...site,
            totalSubject: updatedSubjects,
          };
        }
        return site;
      });
    });
    const indexing = subjectResult?.map((item, index) => ({
      subjectId: item.subjectId,
      index: index,
    }));
    let userData = {
      studyId: studyId,
      type: `studySubject_${siteId}`,
      indexing: indexing,
    };
    await studyOtherSettingsServices.updateTableIndexing(
      userData
    );
  };

  const getStudySiteSubjectList = async () => {
    setSubjectSiteLoader(true)
    let data = await studySiteDataEntryServices.getStudySiteSubjectList(studyId, categoryRole, StudyMode)
    setSubjectSiteLoader(false)
    setSiteSubjectList(data?.data || [])
  }

  const getStudySiteEventDataBasedonSchema = async (siteId, schemaId, subjectId) => {
    setEventLoading(true)
    setSpecialFormStatus("")
    let data = await studySiteDataEntryServices.getStudySiteEventDataBasedonSchema(studyId, siteId, schemaId, subjectId, StudyMode)
    if (data === "AbortError") {
      setEventLoading(true);
    } else {
      setSiteEventList(data?.data || [])
      setSpecialFormStatus(data?.specialFormStatus || "")
      setEventLoading(false)
    }
  }

  const getStudySiteEventTimePointDataBasedonEvent = async (siteId, schemaId, eventId, repeatType, repeatEventId) => {
    setEventTimepointLoading(true)
    setSiteEventTimePointList([])
    let data = await studySiteDataEntryServices.getStudySiteEventTimePointDataBasedonEvent(studyId, siteId, schemaId, eventId, subjectId || activeTabName?.subjectId || "noSubject", repeatType || "no", repeatEventId || "no", StudyMode)
    if (data === "AbortError") {
      setEventTimepointLoading(true);
    } else {
      setSiteEventTimePointList(data?.data || [])
      setEventTimepointLoading(false);
    }
  }

  const handleSubjectAdd = (siteId, siteName, subjectSettings) => {
    setToggle()
    setSiteId(siteId)
    setSiteName(siteName)
    setSubjectSettings(subjectSettings)
  }

  const handleDeletedSubjectHistory = (siteId, siteName) => {
    setToggle1()
    setSiteId(siteId)
    setSiteName(siteName)
  }

  const handleUpdateSubjectData = (siteId, siteName, subjectId, subjectName, subjectSettings, voidData) => {
    setToggle2()
    setSiteId(siteId)
    setSiteName(siteName)
    setSubjectIdForUpdate(subjectId)
    setSubjectName(subjectName)
    setSubjectVoid(voidData)
    setSubjectSettings(subjectSettings)
  }

  const handleViewSiteHistory = (siteId, siteName) => {
    setToggle18()
    setSiteId(siteId)
    setSiteName(siteName)
  }

  const handleViewSubjectGraph = (siteId, siteName) => {
    setToggle3()
    setSiteId(siteId)
    setSiteName(siteName)
  }

  const handleViewSubjectActivity = (subjectId, subjectName, voidData) => {
    setToggle4()
    setSubjectId(subjectId)
    setSubjectName(subjectName)
    setSubjectVoid(voidData)
  }
  const handleViewSubjectHistory = (siteId, subjectId, subjectName, voidData) => {
    setToggle5()
    setSiteId(siteId)
    setSubjectId(subjectId)
    setSubjectName(subjectName)
    setSubjectVoid(voidData)
  }

  const handleViewSubjectDetails = (siteId, subjectId, subject) => {
    setToggle6()
    setSiteId(siteId)
    setSubjectId(subjectId)
    setSubjecDetails(subject)
  }
  const handleViewSiteSubjectGraph = (siteId, subjectId, subjectName, voidData) => {
    setToggle7()
    setSiteId(siteId)
    setSubjectId(subjectId)
    setSubjectName(subjectName)
    setSubjectVoid(voidData)
  }
  const handleViewSubjectMilestone = (subjectId, subjectName, voidData) => {
    setToggle8()
    setSubjectId(subjectId)
    setSubjectName(subjectName)
    setSubjectVoid(voidData)
  }
  const handleViewReviewSettings = (siteId, subjectId, schemaId, subjectName, voidData) => {
    setToggle10()
    setSiteId(siteId)
    setSubjectId(subjectId)
    setSchemaId(schemaId)
    setSubjectName(subjectName)
    setSubjectVoid(voidData)
  }
  const handleViewAssignSDVUser = (siteId, subjectId, schemaId, subjectName, voidData, assignedUser) => {
    setToggle12()
    setSiteId(siteId)
    setSubjectId(subjectId)
    setSchemaId(schemaId)
    setSubjectName(subjectName)
    setSubjectVoid(voidData)
    setAssignedUser(assignedUser)
  }
  const handleViewSendForReviewSettings = (siteId, subjectId, schemaId, subjectName, voidData) => {
    setToggle11()
    setSiteId(siteId)
    setSubjectId(subjectId)
    setSchemaId(schemaId)
    setSubjectName(subjectName)
    setSubjectVoid(voidData)
  }

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);

  const getDeletedStudySubjectRowData = async (pageNumberDeleted, itemsPerPageDeleted) => {
    setDeletedSubjectLoader(true)
    let data = await studySubjectManagementServices.getStudySubjectRowData("deleted", studyId, siteId, StudyMode, "", pageNumberDeleted, itemsPerPageDeleted);
    setSubjectDeletedRows(data?.data || []);
    setSubjectDeletedRowsCount(data?.count || 0);
    setDeletedSubjectLoader(false)
  };

  const softDeleteRestoreStudySubjectRow = async (id, type, siteId, voidData) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} subject!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.id = id;
        userData.studyId = studyId;
        userData.siteId = siteId;
        userData.type = type;
        userData.voidData = voidData;
        let data = await studySubjectManagementServices.softDeleteRestoreStudySubjectRow(userData);
        if (data?.statusCode === 200) {
          getStudySiteSubjectList();
          setSiteId("")
          setSiteName("")
        }
      }
    });
  };

  const repeatStudySubjectEvent = async (siteId, subjectId, schemaId, eventId, timePointUniqueId) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Repeat Event!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Repeat it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.siteId = siteId;
        userData.subjectId = subjectId;
        userData.schemaId = schemaId;
        userData.eventId = eventId;
        userData.timePointUniqueId = timePointUniqueId;
        userData.mode = StudyMode;
        let data = await studySiteDataEntryServices.repeatStudySubjectEvent(userData);
        if (data?.statusCode === 200) {
          getStudySiteEventDataBasedonSchema(siteId, schemaId, subjectId);
        }
      }
    });
  };

  const getStudySubjectDeletedRepeatEventList = async (siteId, subjectId, schemaId) => {
    setDeletedRepeatEventLoader(true)
    let data = await studySiteDataEntryServices.getStudySubjectDeletedRepeatEventList(studyId, siteId, subjectId, schemaId, StudyMode)
    setDeletedRepeatEventList(data?.data || [])
    setDeletedRepeatEventLoader(false)
  };

  const handleDeletedRepeatEventHistory = (siteId, subjectId, schemaId) => {
    setToggle19()
    getStudySubjectDeletedRepeatEventList(siteId, subjectId, schemaId)
  };

  const softDeleteRestoreStudySubjectRepeatEvent = async (siteId, subjectId, schemaId, repeatEvent, type) => {
    const isDelete = type === "delete"
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${isDelete ? "Delete" : "Restore"} Repeated Event ${repeatEvent?.eventName} (R${repeatEvent?.repeatNumber})!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${isDelete ? "Delete" : "Restore"} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.siteId = siteId;
        userData.subjectId = subjectId;
        userData.schemaId = schemaId;
        userData.eventId = repeatEvent?.eventId;
        userData.repeatEventId = repeatEvent?.repeatEventId;
        userData.type = type;
        userData.mode = StudyMode;
        let data = await studySiteDataEntryServices.softDeleteRestoreStudySubjectRepeatEvent(userData);
        if (data?.statusCode === 200) {
          getStudySiteEventDataBasedonSchema(siteId, schemaId, subjectId);
          if (isDelete) {
            if (eventId === repeatEvent?.repeatEventId) {
              handleAddNewTab(
                "Data Management",
                "fa-solid fa-clipboard-list",
                "dataEntry",
                {
                  siteId: activeTabName?.siteId || "",
                  siteName: activeTabName?.siteName || "",
                  subjectId: activeTabName?.subjectId || "",
                  subjectName: activeTabName?.subjectName || "",
                  schemaId: activeTabName?.schemaId || "",
                }
              )
              setOpenTimePointEvents("")
              setEventId("")
              setSiteEventTimePointList([])
            }
          } else {
            getStudySubjectDeletedRepeatEventList(siteId, subjectId, schemaId);
          }
        }
      }
    });
  };

  const updateStudySubjectScreen = async (subjectId, siteId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Subject Eligibility ${status}!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status === "pass" ? "eligible" : status} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setSubjectUpdateLoader(true)
        let userData = {};
        userData.mode = StudyMode;
        userData.subjectId = subjectId;
        userData.siteId = siteId;
        userData.studyId = studyId;
        userData.screeningStatus = status;
        if (reason) {
          userData.reason = reason;
        }
        let data = await studySubjectManagementServices.updateStudySubjectRowData(userData);
        if (data?.statusCode === 200) {
          getStudySiteSubjectList();
          setReason("")
          setSubjectUpdateLoader(false)
          if (status === "pass") {
            setToggle13()
          }
          if (status === "fail") {
            setToggle16()
          }
        }
      }
    });
  };

  const assignRandomizationNumber = (siteId, siteName, subjectId, schemaId, subjectName, subjectSettings, voidData) => {
    setToggle9()
    setSiteId(siteId)
    setSiteName(siteName)
    setSubjectIdForUpdate(subjectId)
    setSchemaId(schemaId)
    setSubjectName(subjectName)
    setSubjectVoid(voidData)
    setSubjectSettings(subjectSettings)
  }

  const reassignRandomizationNumber = (siteId, siteName, subjectId, schemaId, subjectName, subjectSettings, voidData) => {
    setToggle17()
    setSiteId(siteId)
    setSiteName(siteName)
    setSubjectIdForUpdate(subjectId)
    setSchemaId(schemaId)
    setSubjectName(subjectName)
    setSubjectVoid(voidData)
    setSubjectSettings(subjectSettings)
  }

  const updateStudySubjectStatus = async (subjectId, siteId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Subject Status ${status}!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setSubjectStatusLoader(true)
        let userData = {};
        userData.subjectId = subjectId;
        userData.siteId = siteId;
        userData.studyId = studyId;
        userData.mode = StudyMode;
        userData.subjectStatus = status;
        if (reason) {
          userData.reason = reason;
        }
        if (remark) {
          userData.remark = remark;
        }
        if (category) {
          userData.category = category;
        }
        if (completionDate) {
          userData.completionDate = completionDate;
        }
        let data = await studySubjectManagementServices.updateStudySubjectRowData(userData);
        if (data?.statusCode === 200) {
          setSubjectStatusLoader(false)
          setReason("")
          setRemark("")
          setCategory("")
          setCompletionDate("")
          if (status === "discontinue") {
            setToggle14()
          }
          if (status === "complete") {
            setToggle15()
          }
          getStudySiteSubjectList();
        }
      }
    });
  };

  const sendForSubjectPrincipleInvestigator = async (subjectId, siteId) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Subject Send for Principle Investigator Review!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Send it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.subjectId = subjectId;
        userData.siteId = siteId;
        userData.studyId = studyId;
        userData.mode = StudyMode;
        await studySubjectPrincipleInvestigatorServices.sendForSubjectPrincipleInvestigator(userData);
      }
    });
  };

  const updateStudySubjectVoid = async (subjectId, siteId) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Remove Void Label!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Remove it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.subjectId = subjectId;
        userData.siteId = siteId;
        userData.studyId = studyId;
        userData.mode = StudyMode;
        userData.voidData = false;
        let data = await studySubjectManagementServices.updateStudySubjectRowData(userData);
        if (data?.statusCode === 200) {
          getStudySiteSubjectList();
        }
      }
    });
  };

  useEffect(() => {
    if (activeTabName) {
      setOpenEvents(`${activeTabName?.siteId || ""}${activeTabName?.subjectId || ""}`)
      setSchemaId(activeTabName?.schemaId || "")
      setSubjectId(activeTabName?.subjectId || "")
      setSubjectName(activeTabName?.subjectName || "");
      setSubjectVoid(activeTabName?.voidData || "");
      setSiteName(activeTabName?.siteName || "");
      setSiteId(activeTabName?.siteId || "");
      setEventId(activeTabName?.repeatType === "yes" ? (activeTabName?.repeatEventId || "") : (activeTabName?.eventId || ""));
      setEventName(activeTabName?.eventName || "");
      if (activeTabName?.siteId && activeTabName?.schemaId && activeTabName?.eventId) {
        getStudySiteEventTimePointDataBasedonEvent(activeTabName?.siteId || "", activeTabName?.schemaId || "", activeTabName?.eventId || "", activeTabName?.repeatType || "no", activeTabName?.repeatEventId || "no")
      }
      setOpenTimePointEvents(`${activeTabName?.schemaId || ""}${(activeTabName?.repeatType === "yes" ? (activeTabName?.repeatEventId || "") : (activeTabName?.eventId || "")) || "no"}`)
    }
  }, [activeTabName]);

  useEffect(() => {
    if (activeTabName?.siteId && activeTabName?.schemaId && activeTabName?.subjectId) {
      getStudySiteEventDataBasedonSchema(activeTabName?.siteId || "", activeTabName?.schemaId || "", activeTabName?.subjectId || "");
    }
  }, [activeTabName?.siteId, activeTabName?.schemaId, activeTabName?.subjectId]);

  useEffect(() => {
    if (activeTabName?.siteId && activeTabName?.schemaId && activeTabName?.eventId) {
      getStudySiteEventTimePointDataBasedonEvent(activeTabName?.siteId || "", activeTabName?.schemaId || "", activeTabName?.eventId || "", activeTabName?.repeatType || "no", activeTabName?.repeatEventId || "")
    }
  }, [activeTabName?.siteId, activeTabName?.schemaId, activeTabName?.eventId]);

  useEffect(() => {
    getStudySiteSubjectList();
  }, []);

  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"100%"}
        className="position-relative"
        style={{ height: "calc(100vh - 144px)" }}
      >
        {subjectSiteLoader ? (
          <PageLoader />
        ) : siteSubjectList?.length === 0 ? (
          <NoDataFoundTable MSG={"Subject not found!"} />
        ) : (
          <div className="d-flex gap-2 p-2 overflow-auto bg-light ">
            {siteSubjectList?.map((site, index) => (
              <>
                <div key={index} ref={AppsRef}>
                  <div className="border br3 bg-white" style={{ width: 270 }}>
                    <div className="border-bottom p-2 hstack justify-content-between">
                      <Form.Label className="m-0 fw-bold">{site?.siteName}</Form.Label>
                      <div className="d-flex gap-3">
                        <BsBarChartLineFill
                          title="View Site Graph"
                          className="CP"
                          style={{ color: "var(--blue)" }}
                          onClick={() => handleViewSubjectGraph(site?.siteId, site?.siteName)}
                        />
                        <FaHistory
                          title="View Site History"
                          className="CP"
                          style={{ color: "var(--blue)" }}
                          onClick={() => handleViewSiteHistory(site?.siteId, site?.siteName)}
                        />
                        {!(StudyMode?.startsWith("SDV")) &&
                          <>
                            {((StudyMode === "DBP Mode" || studyPermission?.liveSubjectCreate || studyPermission?.qcSubjectCreate) || !(studyPermission?.qcReadOnly || studyPermission?.liveReadOnly)) &&
                              <FaRegPlusSquare
                                title="Add New Subject"
                                className="CP"
                                style={{ color: "var(--blue)" }}
                                onClick={() => handleSubjectAdd(site?.siteId, site?.siteName, site?.subjectSettings)}
                              />
                            }
                            <MdOutlineAutoDelete
                              title="View Deleted Subjects"
                              className="text-danger CP"
                              onClick={() => handleDeletedSubjectHistory(site?.siteId, site?.siteName)}
                            />
                          </>
                        }
                      </div>
                    </div>
                    <div
                      className="overflow-auto"
                      style={{ height: "calc(100vh - 202px)" }}
                    >
                      <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable droppableId={site?.siteId}>
                          {(provided) => (
                            <div {...provided.droppableProps} ref={provided.innerRef}>
                              {site?.totalSubject?.map((subject, index) => (
                                <Draggable key={subject.subjectId} draggableId={String(subject.subjectId)} index={index}>
                                  {(provided) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      className="d-flex p-2 gap-3 bg-white justify-content-between border-bottom border-0"
                                    >
                                      <div className="hstack gap-2 align-items-end">
                                        <div>
                                          <img
                                            src={(subject?.screeningStatus === "fail" || subject?.criteriaFailed) ? ((subject?.subjectGender)?.toLowerCase() === "male" ? ManIconRed : (subject?.subjectGender)?.toLowerCase() === "female" ? WomanIconRed : UnknownIconRed) : subject?.subjectStatus === "discontinue" ? ((subject?.subjectGender)?.toLowerCase() === "male" ? ManIconRed : (subject?.subjectGender)?.toLowerCase() === "female" ? WomanIconRed : UnknownIconRed) : subject?.subjectStatus === "completed" ? ((subject?.subjectGender)?.toLowerCase() === "male" ? ManIconHighlighted : (subject?.subjectGender)?.toLowerCase() === "female" ? WomanIconHighlighted : UnknownIconHighlighted) : ((subject?.subjectGender)?.toLowerCase() === "male" ? ManIconInitiate : (subject?.subjectGender)?.toLowerCase() === "female" ? WomanIconInitiate : UnknownIconInitiate)}
                                            alt=""
                                            style={{ width: 25, height: 25 }}
                                          />
                                          <div>
                                            {(subject?.screeningStatus === "fail" || subject?.criteriaFailed) ?
                                              <Badge title={subject?.criteriaFailed ? "Screening Criteria Failed" : "Screening Failed"} bg="danger-subtle" className="br3 text-dark" style={{ fontSize: 10 }}>SF</Badge>
                                              : (subject?.subjectStatus === "completed") ?
                                                <Badge title="Status Completed" bg="success-subtle" className="br3 text-dark" style={{ fontSize: 10 }}>CP</Badge>
                                                : (subject?.subjectStatus === "discontinue") ?
                                                  <Badge title="Status Discontinue" bg="danger-subtle" className="br3 text-dark" style={{ fontSize: 10 }}>DC</Badge>
                                                  : (subject?.assignRandomizer) ?
                                                    <Badge title="Subject Randomized" bg={(subject?.screeningStatus === "fail" || subject?.criteriaFailed) ? "danger-subtle" : subject?.subjectStatus === "discontinue" ? "danger-subtle" : subject?.subjectStatus === "completed" ? "success-subtle" : "primary-subtle"} className="br3 text-dark" style={{ fontSize: 10 }}>RD</Badge>
                                                    : (subject?.screeningStatus === "pass" && !subject?.criteriaFailed) &&
                                                    <Badge title="Eligiblityed" bg={(subject?.screeningStatus === "fail" || subject?.criteriaFailed) ? "danger-subtle" : subject?.subjectStatus === "discontinue" ? "danger-subtle" : subject?.subjectStatus === "completed" ? "success-subtle" : "primary-subtle"} className="br3 text-dark" style={{ fontSize: 10 }}>SP</Badge>
                                            }
                                          </div>
                                        </div>
                                        <div>
                                          <Form.Label title={subject?.assignName} style={{ fontSize: 12 }} className="fw-bold m-0">
                                            {subject?.subjectName} {subject?.voidData && "(VOID)"}
                                          </Form.Label>
                                          <div>
                                            <Badge
                                              className={`br3 p-1 px-2 ${subject?.subjectId === subjectId ? "text-white" : "text-dark"} CP`}
                                              bg={(subject?.screeningStatus === "fail" || subject?.criteriaFailed) ? (subject?.subjectId === subjectId ? "danger" : "danger-subtle") : subject?.subjectStatus === "discontinue" ? (subject?.subjectId === subjectId ? "danger" : "danger-subtle") : subject?.subjectStatus === "completed" ? (subject?.subjectId === subjectId ? "success" : "success-subtle") : (subject?.subjectId === subjectId ? "primary" : "primary-subtle")}
                                              style={{ fontSize: 10 }}
                                              onClick={() => {
                                                if (openEvents === `${site?.siteId}${subject?.subjectId}`) {
                                                  handleAddNewTab(
                                                    "Data Management",
                                                    "fa-solid fa-clipboard-list",
                                                    "dataEntry"
                                                  )
                                                  setSchemaId("")
                                                  setSubjectName("");
                                                  setSubjectVoid(false);
                                                  setOpenEvents("")
                                                  setSubjectId("")
                                                  setOpenTimePointEvents("")
                                                  setEventId("")
                                                } else {
                                                  handleAddNewTab(
                                                    "Data Management",
                                                    "fa-solid fa-clipboard-list",
                                                    "dataEntry",
                                                    {
                                                      siteId: site?.siteId,
                                                      schemaId: subject?.schemaId,
                                                      subjectId: subject?.subjectId,
                                                      siteName: site?.siteName,
                                                      subjectName: subject?.subjectName,
                                                    }
                                                  )
                                                  getStudySiteEventDataBasedonSchema(site?.siteId, subject?.schemaId, subject?.subjectId);
                                                  setOpenEvents(`${site?.siteId}${subject?.subjectId}`)
                                                  setSchemaId(subject?.schemaId)
                                                  setSubjectId(subject?.subjectId)
                                                  setSubjectName(subject?.subjectName);
                                                  setSubjectVoid(subject?.voidData);
                                                  setSiteName(site?.siteName);
                                                  setSiteId(site?.siteId);
                                                }
                                              }}
                                              title="View Events"
                                            >
                                              View Events
                                            </Badge>
                                          </div>
                                        </div>
                                      </div>
                                      {(StudyMode === "DBP Mode" || !(studyPermission?.qcReadOnly || studyPermission?.liveReadOnly)) && !(StudyMode?.startsWith("SDV")) &&
                                        <div className="position-relative">
                                          <div className="text-end">
                                            <button className={`${openAction === subject?.subjectId ? "border br3 bg-main text-white" : "border br3"}`} style={{ fontSize: 12, padding: "1px 2px", borderRadius: 3 }}
                                              onClick={() => setOpenAction(openAction === subject?.subjectId ? "" : subject?.subjectId)}
                                            >
                                              <CiMenuKebab />
                                            </button>
                                            <br />
                                            {!subject?.assignRandomizer &&
                                              <>
                                                <Badge
                                                  className={`br3 p-1 px-2 border border-muted text-dark CP`}
                                                  bg={"white"}
                                                  style={{ fontSize: 10 }}
                                                  onClick={() => {
                                                    if (!subject?.screeningStatus || subject?.screeningStatus === "fail") {
                                                      setToggle13();
                                                      setSubjectId(subject?.subjectId)
                                                      setSiteId(site?.siteId)
                                                      setSiteName(site?.siteName)
                                                      setSubjectName(subject?.subjectName)
                                                    }
                                                    if (site?.subjectSettings === "IWRS" && !subject?.assignRandomizer && subject?.screeningStatus === "pass") {
                                                      assignRandomizationNumber(site?.siteId, site?.siteName, subject?.subjectId, subject?.schemaId, subject?.subjectName, site?.subjectSettings, subject?.voidData)
                                                    }
                                                  }}
                                                  title={(site?.subjectSettings === "IWRS" && !subject?.assignRandomizer && subject?.screeningStatus === "pass") ? "Assign Random No."
                                                    : (!subject?.screeningStatus || subject?.screeningStatus === "fail") ? "Eligiblity"
                                                      : ""
                                                  }
                                                >
                                                  {(site?.subjectSettings === "IWRS" && !subject?.assignRandomizer && subject?.screeningStatus === "pass") ? <><FaLongArrowAltRight /> Assign Random No.</>
                                                    : (!subject?.screeningStatus || subject?.screeningStatus === "fail") ? <><FaLongArrowAltRight /> Eligiblity</>
                                                      : ""
                                                  }
                                                </Badge>
                                              </>
                                            }
                                          </div>
                                          <Collapse in={openAction === subject?.subjectId}>
                                            <div className="position-absolute end-0" style={{ width: "max-content", zIndex: 9999 }}>
                                              <ListGroup className="br3">
                                                {((StudyMode === "DBP Mode" || studyPermission?.liveSubjectAction || studyPermission?.qcSubjectAction) || !(studyPermission?.qcReadOnly || studyPermission?.liveReadOnly)) &&
                                                  <>
                                                    {!subject?.voidData ?
                                                      <>
                                                        <ListGroup.Item
                                                          action style={{ fontSize: 12 }}
                                                          className="text-nowrap py-1 px-3 hstack text-primary"
                                                          title="Update Subject Details"
                                                          onClick={() => handleUpdateSubjectData(site?.siteId, site?.siteName, subject?.subjectId, subject?.subjectName, site?.subjectSettings, subject?.voidData)}
                                                        >
                                                          <FaEdit className="me-2" />Update Subject Details
                                                        </ListGroup.Item>
                                                        {(!subject?.screeningStatus || subject?.screeningStatus === "fail" || subject?.criteriaFailed) &&
                                                          <ListGroup.Item
                                                            action style={{ fontSize: 12 }}
                                                            className="text-nowrap py-1 px-3 hstack text-success"
                                                            title="Check Eligiblity"
                                                            onClick={() => {
                                                              setToggle13();
                                                              setSubjectId(subject?.subjectId);
                                                              setSiteId(site?.siteId)
                                                              setSiteName(site?.siteName)
                                                              setSubjectName(subject?.subjectName)
                                                            }}
                                                          >
                                                            <FaCircleCheck className="me-2" />Check Eligiblity
                                                          </ListGroup.Item>
                                                        }
                                                        {(!subject?.screeningStatus || subject?.screeningStatus || subject?.screeningStatus === "pass") &&
                                                          <ListGroup.Item
                                                            action style={{ fontSize: 12 }}
                                                            className="text-nowrap py-1 px-3 hstack text-danger"
                                                            title="Mark Screening Fail"
                                                            onClick={() => {
                                                              setToggle16();
                                                              setSubjectId(subject?.subjectId);
                                                              setSiteId(site?.siteId)
                                                              setSiteName(site?.siteName)
                                                              setSubjectName(subject?.subjectName)
                                                            }}
                                                          >
                                                            <FaCircleXmark className="me-2" />Mark Screening Fail
                                                          </ListGroup.Item>
                                                        }
                                                        {(site?.subjectSettings === "IWRS" && !subject?.assignRandomizer && subject?.screeningStatus === "pass") &&
                                                          <ListGroup.Item
                                                            action style={{ fontSize: 12 }}
                                                            className="text-nowrap py-1 px-3 hstack text-success"
                                                            title="Assign Randomization No."
                                                            onClick={() => assignRandomizationNumber(site?.siteId, site?.siteName, subject?.subjectId, subject?.schemaId, subject?.subjectName, site?.subjectSettings, subject?.voidData)}
                                                          >
                                                            <FaRandom className="me-2" />Assign Randomization No.
                                                          </ListGroup.Item>
                                                        }
                                                        {(site?.subjectSettings === "IWRS" && !subject?.subjectRandomized && subject?.assignRandomizer && subject?.screeningStatus === "pass") &&
                                                          <ListGroup.Item
                                                            action style={{ fontSize: 12 }}
                                                            className="text-nowrap py-1 px-3 hstack text-success"
                                                            title="Re-assign Randomization Schema"
                                                            onClick={() => reassignRandomizationNumber(site?.siteId, site?.siteName, subject?.subjectId, subject?.schemaId, subject?.subjectName, site?.subjectSettings, subject?.voidData)}
                                                          >
                                                            <FaRandom className="me-2" />Re-assign Randomization Schema
                                                          </ListGroup.Item>
                                                        }
                                                        {subject?.subjectStatus === "discontinue" ?
                                                          <>
                                                            <ListGroup.Item
                                                              action style={{ fontSize: 12 }}
                                                              className="text-nowrap py-1 px-3 hstack text-warning"
                                                              title="Update in Ongoing Status"
                                                              onClick={() => updateStudySubjectStatus(subject?.subjectId, site?.siteId, "ongoing")}
                                                            >
                                                              <FaArrowsSpin className="me-2" />Update in Ongoing Status
                                                            </ListGroup.Item>
                                                          </>
                                                          : subject?.subjectStatus === "completed" ?
                                                            <>
                                                              <ListGroup.Item
                                                                action style={{ fontSize: 12 }}
                                                                className="text-nowrap py-1 px-3 hstack text-warning"
                                                                title="Update in Ongoing Status"
                                                                onClick={() => updateStudySubjectStatus(subject?.subjectId, site?.siteId, "ongoing")}
                                                              >
                                                                <FaArrowsSpin className="me-2" />Update in Ongoing Status
                                                              </ListGroup.Item>
                                                              <ListGroup.Item
                                                                action style={{ fontSize: 12 }}
                                                                className="text-nowrap py-1 px-3 hstack text-danger"
                                                                title="Update in Discontinue Status"
                                                                onClick={() => {
                                                                  setToggle14();
                                                                  setSubjectId(subject?.subjectId);
                                                                  setSiteId(site?.siteId)
                                                                  setSiteName(site?.siteName)
                                                                  setSubjectName(subject?.subjectName)
                                                                }}
                                                              >
                                                                <FaRegCircleXmark className="me-2" />Update in Discontinue Status
                                                              </ListGroup.Item>
                                                            </>
                                                            : subject?.screeningStatus === "pass" &&
                                                            <>
                                                              <ListGroup.Item
                                                                action style={{ fontSize: 12 }}
                                                                className="text-nowrap py-1 px-3 hstack text-success"
                                                                title="Update in Complete Status"
                                                                onClick={() => {
                                                                  setToggle15();
                                                                  setSubjectId(subject?.subjectId);
                                                                  setSiteId(site?.siteId)
                                                                  setSiteName(site?.siteName)
                                                                  setSubjectName(subject?.subjectName)
                                                                }}
                                                              >
                                                                <FaRegCheckCircle className="me-2" />Update in Complete Status
                                                              </ListGroup.Item>
                                                              {subject?.subjectStatus !== "discontinue" &&
                                                                <ListGroup.Item
                                                                  action style={{ fontSize: 12 }}
                                                                  className="text-nowrap py-1 px-3 hstack text-danger"
                                                                  title="Update in Discontinue Status"
                                                                  onClick={() => {
                                                                    setToggle14();
                                                                    setSubjectId(subject?.subjectId);
                                                                    setSiteId(site?.siteId)
                                                                    setSiteName(site?.siteName)
                                                                    setSubjectName(subject?.subjectName)
                                                                  }}
                                                                >
                                                                  <FaRegCircleXmark className="me-2" />Update in Discontinue Status
                                                                </ListGroup.Item>
                                                              }
                                                            </>
                                                        }
                                                      </>
                                                      :
                                                      <ListGroup.Item
                                                        action style={{ fontSize: 12 }}
                                                        className="text-nowrap py-1 px-3 hstack text-danger"
                                                        title="Remove Void Label"
                                                        onClick={() => updateStudySubjectVoid(subject?.subjectId, site?.siteId)}
                                                      >
                                                        <FaRegCircleXmark className="me-2" />Remove Void Label
                                                      </ListGroup.Item>
                                                    }
                                                  </>
                                                }
                                                <ListGroup.Item
                                                  action style={{ fontSize: 12 }}
                                                  className="text-nowrap py-1 px-3 hstack text-secondary"
                                                  title="View Subject History"
                                                  onClick={() => handleViewSubjectHistory(site?.siteId, subject?.subjectId, subject?.subjectName, subject?.voidData)}
                                                >
                                                  <RiChatHistoryLine className="me-2" />View Subject History
                                                </ListGroup.Item>
                                                <ListGroup.Item
                                                  action style={{ fontSize: 12 }}
                                                  className="text-nowrap py-1 px-3 hstack text-secondary"
                                                  title="View Subject Activities"
                                                  onClick={() => handleViewSubjectActivity(subject?.subjectId, subject?.subjectName, subject?.voidData)}
                                                >
                                                  <FiActivity className="me-2" />View Subject Activities
                                                </ListGroup.Item>
                                                <ListGroup.Item
                                                  action style={{ fontSize: 12 }}
                                                  className="text-nowrap py-1 px-3 hstack text-secondary"
                                                  title="View Subject Details"
                                                  onClick={() => handleViewSubjectDetails(site?.siteId, subject?.subjectId, subject)}
                                                >
                                                  <BiDetail className="me-2" />View Subject Details
                                                </ListGroup.Item>
                                                <ListGroup.Item
                                                  action style={{ fontSize: 12 }}
                                                  className="text-nowrap py-1 px-3 hstack text-secondary"
                                                  title="View Subject Timeline"
                                                  onClick={() => handleViewSubjectMilestone(subject?.subjectId, subject?.subjectName, subject?.voidData)}
                                                >
                                                  <MdTimeline className="me-2" />View Subject Timeline
                                                </ListGroup.Item>
                                                <ListGroup.Item
                                                  action style={{ fontSize: 12 }}
                                                  className="text-nowrap py-1 px-3 hstack text-secondary"
                                                  title="View Subject Statistics"
                                                  onClick={() => handleViewSiteSubjectGraph(site?.siteId, subject?.subjectId, subject?.subjectName, subject?.voidData)}
                                                >
                                                  <IoIosStats className="me-2" />View Subject Statistics
                                                </ListGroup.Item>
                                                {/* <ListGroup.Item
                                                  action style={{ fontSize: 12 }}
                                                  className="text-nowrap py-1 px-3 hstack text-secondary"
                                                  title="View Form Report"
                                                  onClick={() => handleAddNewTab(
                                                    "Form Report",
                                                    "fa-solid fa-clipboard-list",
                                                    "subjectFormReport"
                                                  )}
                                                >
                                                  <TbReportAnalytics className="me-2" />View Form Report
                                                </ListGroup.Item>
                                                <ListGroup.Item
                                                  action style={{ fontSize: 12 }}
                                                  className="text-nowrap py-1 px-3 hstack text-secondary"
                                                  title="Investigator Signature"
                                                  onClick={() => handleAddNewTab(
                                                    "Investigator Signature",
                                                    "fa-solid fa-clipboard-list",
                                                    "subjectInvestigatorSignature"
                                                  )}
                                                >
                                                  <FaSignature className="me-2" />Investigator Signature
                                                </ListGroup.Item> */}
                                                {((StudyMode === "DBP Mode" || !(studyPermission?.qcReadOnly || studyPermission?.liveReadOnly)) && (studyPermission?.liveMedicalReview || studyPermission?.qcMedicalReview)) &&
                                                  <>
                                                    <ListGroup.Item
                                                      action style={{ fontSize: 12 }}
                                                      className="text-nowrap py-1 px-3 hstack text-secondary"
                                                      title="Send for Medical Review"
                                                      onClick={() => handleViewSendForReviewSettings(site?.siteId, subject?.subjectId, subject?.schemaId, subject?.subjectName, subject?.voidData)}
                                                    >
                                                      <FiSend className="me-2" />Send for Medical Review
                                                    </ListGroup.Item>
                                                    <ListGroup.Item
                                                      action style={{ fontSize: 12 }}
                                                      className="text-nowrap py-1 px-3 hstack text-secondary"
                                                      title="Medical Review Settings"
                                                      onClick={() => handleViewReviewSettings(site?.siteId, subject?.subjectId, subject?.schemaId, subject?.subjectName, subject?.voidData)}
                                                    >
                                                      <CiMedicalClipboard className="me-2" />Medical Review Settings
                                                    </ListGroup.Item>
                                                  </>
                                                }
                                                {((StudyMode === "DBP Mode" || !(studyPermission?.qcReadOnly || studyPermission?.liveReadOnly)) && subject?.subjectStatus === "completed" && (studyPermission?.liveInvestigatorSignature || studyPermission?.qcInvestigatorSignature)) &&
                                                  <ListGroup.Item
                                                    action style={{ fontSize: 12 }}
                                                    className="text-nowrap py-1 px-3 hstack text-secondary"
                                                    title="Send for Principle Investigator"
                                                    onClick={() => sendForSubjectPrincipleInvestigator(subject?.subjectId, site?.siteId)}
                                                  >
                                                    <FiSend className="me-2" />Send for Principle Investigator
                                                  </ListGroup.Item>
                                                }
                                                {((StudyMode === "DBP Mode" || !(studyPermission?.qcReadOnly || studyPermission?.liveReadOnly)) && !StudyMode?.startsWith("SDV")) &&
                                                  <ListGroup.Item
                                                    action style={{ fontSize: 12 }}
                                                    className="text-nowrap py-1 px-3 hstack text-secondary"
                                                    title={`${subject?.assignedSDVUser?.length > 0 ? "Re-Assign" : "Assign"} Form SDV User`}
                                                    onClick={() => handleViewAssignSDVUser(site?.siteId, subject?.subjectId, subject?.schemaId, subject?.subjectName, subject?.voidData, subject?.assignedSDVUser)}
                                                  >
                                                    <MdOutlineAssignmentTurnedIn className="me-2" />{subject?.assignedSDVUser?.length > 0 ? "Re-Assign" : "Assign"} Form SDV User
                                                  </ListGroup.Item>
                                                }
                                                {((StudyMode === "DBP Mode" || studyPermission?.liveSubjectDelete || studyPermission?.qcSubjectDelete) || !(studyPermission?.qcReadOnly || studyPermission?.liveReadOnly)) &&
                                                  <ListGroup.Item
                                                    action style={{ fontSize: 12 }}
                                                    className="text-nowrap py-1 px-3 hstack text-danger"
                                                    title="Delete Subject"
                                                    onClick={() => softDeleteRestoreStudySubjectRow(subject?.subjectId, "delete", site?.siteId)}
                                                  >
                                                    <FaTrash className="me-2" />Delete Subject
                                                  </ListGroup.Item>
                                                }
                                              </ListGroup>
                                            </div>
                                          </Collapse>
                                        </div>
                                      }
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </div>
                  </div>
                </div>
                <Collapse in={openEvents === `${site?.siteId}${subjectId}`} dimension="width">
                  <div>
                    <div className="d-flex gap-2">
                      <div className="border bg-white" style={{ minWidth: 200, borderRadius: 3 }}>
                        <div className="border-bottom p-2">
                          <div className="hstack justify-content-between">
                            <Form.Label className="m-0 fw-bold">
                              {subjectName} {subjectVoid ? "(VOID)" : ""}
                            </Form.Label>
                            <div className="d-flex gap-2 align-items-center">
                              {canDeleteRepeatEvent &&
                                <MdOutlineAutoDelete
                                  title="View Deleted Repeated Events"
                                  className="text-danger CP"
                                  onClick={() => handleDeletedRepeatEventHistory(site?.siteId, subjectId, activeTabName?.schemaId || schemaId)}
                                />
                              }
                              <IoIosCloseCircleOutline
                                className="text-danger CP"
                                title={`Close ${subjectName} ${subjectVoid ? "(VOID)" : ""}`}
                                onClick={() => {
                                  handleAddNewTab(
                                    "Data Management",
                                    "fa-solid fa-clipboard-list",
                                    "dataEntry",
                                  )
                                  setSchemaId("")
                                  setSubjectName("");
                                  setSubjectVoid(false);
                                  setOpenEvents("")
                                  setSubjectId("")
                                  setOpenTimePointEvents("")
                                  setEventId("")
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="overflow-auto p-2" style={{ maxHeight: "calc(100vh - 202px)" }}>
                          {eventLoading ? (
                            <div
                              className="hstack justify-content-center"
                              style={{ height: "calc(100vh - 400px)" }}
                            >
                              <PageLoader />
                            </div>
                          ) :
                            siteEventList?.map((event, i) => (
                              <div key={i}>
                                <Badge
                                  bg={(event?.repeat === "Repeated" ? event?.repeatEventId : event?.eventId) === eventId ? (event?.status === "disabled" ? "secondary" : event?.status === "query" ? "danger" : event?.status === "queryNotify" ? "purple" : event?.status === "entry" ? "warning" : event?.status === "reviewed" ? "success" : "primary") : (event?.status === "disabled" ? "secondary-subtle" : event?.status === "query" ? "danger-subtle" : event?.status === "queryNotify" ? "purple-subtle" : event?.status === "entry" ? "warning-subtle" : event?.status === "reviewed" ? "success-subtle" : "primary-subtle")}
                                  style={{
                                    fontSize: 10,
                                    whiteSpace: "normal",
                                    overflowWrap: "break-word",
                                    textAlign: "left",
                                    lineHeight: 1.5,
                                    borderRadius: 3,
                                    cursor: event?.status === "disabled" ? "no-drop" : "pointer"
                                  }}
                                  className={`br3 p-1 px-2 w-100 app-card ${(event?.repeat === "Repeated" ? event?.repeatEventId : event?.eventId) === eventId ? "text-white" : (event?.status === "disabled" ? "text-secondary" : "text-dark")} CP`}
                                >
                                  <div className="w-100 hstack">
                                    <div className="w-75"
                                      title={`Time Point : ${event?.timePoint}`}
                                      onClick={() => {
                                        if (event?.timePoint === "Yes" && event?.status !== "disabled") {
                                          if (openTimePointEvents === `${event?.schemaId}${(event?.repeat === "Repeated" ? event?.repeatEventId : event?.eventId)}`) {
                                            handleAddNewTab(
                                              "Data Management",
                                              "fa-solid fa-clipboard-list",
                                              "dataEntry",
                                              {
                                                siteId: activeTabName?.siteId || "",
                                                siteName: activeTabName?.siteName || "",
                                                subjectId: activeTabName?.subjectId || "",
                                                subjectName: activeTabName?.subjectName || "",
                                                schemaId: activeTabName?.schemaId || "",
                                              }
                                            )
                                            setOpenTimePointEvents("")
                                            setEventId("")
                                          } else {
                                            handleAddNewTab(
                                              "Data Management",
                                              "fa-solid fa-clipboard-list",
                                              "dataEntry",
                                              {
                                                siteId: activeTabName?.siteId || "",
                                                siteName: activeTabName?.siteName || "",
                                                subjectId: activeTabName?.subjectId || "",
                                                subjectName: activeTabName?.subjectName || "",
                                                schemaId: event?.schemaId,
                                                eventId: event?.eventId,
                                                eventName: event?.eventName,
                                                timePointUniqueId: "",
                                                repeatEventId: event?.repeatEventId,
                                                repeatTimePointId: "",
                                                repeatType: event?.repeat === "Repeated" ? "yes" : "no",
                                              }
                                            )
                                            getStudySiteEventTimePointDataBasedonEvent(site?.siteId, event?.schemaId, event?.eventId, event?.repeat === "Repeated" ? "yes" : "no", event?.repeatEventId || "no")
                                            setEventName(event?.eventName)
                                            setSchemaId(event?.schemaId)
                                            setOpenTimePointEvents(`${event?.schemaId}${event?.repeat === "Repeated" ? event?.repeatEventId : event?.eventId || "no"}`)
                                            setEventId(event?.repeat === "Repeated" ? event?.repeatEventId : event?.eventId)
                                          }
                                        } else {
                                          if (event?.status !== "disabled") {
                                            handleAddNewTab(
                                              `Site: ${siteName} - Subject: ${subjectName} ${subjectVoid ? "(VOID)" : ""} - Event: ${event?.eventName} ${event?.repeat === "Repeated" ? `(R${event?.repeatNumber})` : ""}`, "",
                                              `viewEventSchemaFormLists_${site?.siteId}_${subjectId}_${event?.eventId}_${event?.repeatEventId || "repeatEventId"}`,
                                              {
                                                siteId: site?.siteId,
                                                subjectId: subjectId,
                                                siteName: siteName,
                                                subjectName: subjectName,
                                                eventName: event?.eventName,
                                                timePointLabel: "",
                                                schemaId: event?.schemaId,
                                                type: event?.unscheduledEvent === "Yes" ? "unscheduledForm" : "eventForm",
                                                viewType: "dataEntry",
                                                eventId: event?.eventId,
                                                timePointUniqueId: "",
                                                repeatEventId: event?.repeatEventId || "",
                                                repeatTimePointId: "",
                                              }
                                            );
                                          }
                                        }
                                      }}>
                                      {event?.eventName}
                                    </div>
                                    {(!(StudyMode?.startsWith("SDV"))) ?
                                      <div
                                        onClick={() => {
                                          if (event?.repeat === "Repeated") {
                                            if (!canDeleteRepeatEvent) {
                                              return
                                            }
                                            if (event?.status !== "disabled") {
                                              softDeleteRestoreStudySubjectRepeatEvent(site?.siteId, subjectId, event?.schemaId, event, "delete")
                                            } else {
                                              handleResponse({
                                                statusCode: 400,
                                                customMessage: "First unlock this Event!"
                                              })
                                            }
                                          } else if (event?.repeat === "Yes" && event?.status !== "disabled") {
                                            repeatStudySubjectEvent(site?.siteId, subjectId, event?.schemaId, event?.eventId)
                                          } else {
                                            handleResponse({
                                              statusCode: 400,
                                              customMessage: "First unlock this Event!"
                                            })
                                          }
                                        }}
                                        className="w-25 text-end hstack justify-content-end gap-1" title={event?.repeat === "Repeated" ? (canDeleteRepeatEvent ? `Delete Repeat ${event?.repeatNumber}` : `Repeat ${event?.repeatNumber}`) : event?.repeat === "Yes" && "Repeat Event"}>
                                        {event?.repeat === "Repeated" ? <>{`R${event?.repeatNumber}`}{canDeleteRepeatEvent && <FaTrash className="text-danger" style={{ fontSize: 9 }} />}</> : event?.repeat === "Yes" && <MdRepeatOne style={{ fontSize: 16 }} />}
                                      </div>
                                      :
                                      <div
                                        className="w-25 text-end" title={event?.repeat === "Repeated" && `Repeat ${event?.repeatNumber}`}>
                                        {event?.repeat === "Repeated" && `R${event?.repeatNumber}`}
                                      </div>
                                    }
                                  </div>
                                </Badge>
                              </div>
                            ))}
                          {(schemaId && specialFormStatus) &&
                            <div>
                              <Badge
                                bg={specialFormStatus === "query" ? "danger-subtle" : specialFormStatus === "queryNotify" ? "purple-subtle" : specialFormStatus === "reviewed" ? "success-subtle" : specialFormStatus === "entry" ? "warning-subtle" : "primary-subtle"}
                                style={{
                                  fontSize: 10,
                                  whiteSpace: "normal",
                                  overflowWrap: "break-word",
                                  textAlign: "left",
                                  lineHeight: 1.5,
                                  borderRadius: 3
                                }}
                                onClick={() => handleAddNewTab(
                                  `Site: ${siteName} - Subject: ${subjectName} ${subjectVoid ? "(VOID)" : ""} - Event: Special Event`, "",
                                  `viewEventSchemaFormLists_${site?.siteId}_${subjectId}_${subjectId}SpecialForm`,
                                  {
                                    siteId: site?.siteId,
                                    subjectId: subjectId,
                                    schemaId: schemaId,
                                    siteName: siteName,
                                    subjectName: subjectName,
                                    timePointLabel: "",
                                    eventName: "Special Form",
                                    type: "specialForm",
                                    viewType: "dataEntry",
                                    eventId: `${subjectId}SpecialForm`,
                                    timePointUniqueId: "",
                                    repeatEventId: "",
                                    repeatTimePointId: ""
                                  }
                                )}
                                className="br3 p-1 px-2 text-dark CP w-100 app-card"
                                title="View Special Event"
                              >
                                Special Event
                              </Badge>
                            </div>
                          }
                        </div>
                      </div>
                      <Collapse in={openTimePointEvents === `${schemaId}${eventId}`} dimension="width">
                        <div>
                          <div className="border bg-white" style={{ minWidth: 200, borderRadius: 3 }}>
                            <div className="border-bottom p-2">
                              <div className="hstack justify-content-between">
                                <Form.Label className="m-0 fw-bold">
                                  {eventName}
                                </Form.Label>
                                <IoIosCloseCircleOutline
                                  className="text-danger CP"
                                  title={`Close ${eventName}`}
                                  onClick={() => {
                                    setOpenTimePointEvents("")
                                    setEventId("")
                                    handleAddNewTab(
                                      "Data Management",
                                      "fa-solid fa-clipboard-list",
                                      "dataEntry",
                                      {
                                        siteId: activeTabName?.siteId || "",
                                        siteName: activeTabName?.siteName || "",
                                        subjectId: activeTabName?.subjectId || "",
                                        subjectName: activeTabName?.subjectName || "",
                                        schemaId: activeTabName?.schemaId || "",
                                      }
                                    )
                                  }}
                                />
                              </div>
                            </div>
                            <div className="overflow-auto px-2 pb-2" style={{ maxHeight: "calc(100vh - 202px)" }}>
                              {eventTimepointLoading ? (
                                <div
                                  className="hstack justify-content-center"
                                  style={{ height: "calc(100vh - 400px)" }}
                                >
                                  <PageLoader />
                                </div>
                              ) :
                                siteEventTimePointList?.map((timePoint, inx) => (
                                  <div key={inx}>
                                    <Badge
                                      bg={timePoint?.status === "disabled" ? "secondary-subtle" : timePoint?.status === "query" ? "danger-subtle" : timePoint?.status === "queryNotify" ? "purple-subtle" : timePoint?.status === "entry" ? "warning-subtle" : timePoint?.status === "reviewed" ? "success-subtle" : "primary-subtle"}
                                      style={{
                                        fontSize: 10,
                                        whiteSpace: "normal",
                                        overflowWrap: "break-word",
                                        textAlign: "left",
                                        lineHeight: 1.5,
                                        borderRadius: 3,
                                        cursor: timePoint?.status === "disabled" ? "no-drop" : "pointer"
                                      }}
                                      className={`br3 p-1 px-2 ${timePoint?.status === "disabled" ? "text-secondary" : "text-dark"} CP w-100 app-card`}
                                    >
                                      <div className="w-100 hstack">
                                        <div className="w-75"
                                          title={timePoint?.timePointLabel}
                                          onClick={() => {
                                            if (timePoint?.status !== "disabled") {
                                              handleAddNewTab(
                                                `Site: ${siteName} - Subject: ${subjectName} ${subjectVoid ? "(VOID)" : ""} - Event: ${timePoint?.eventName} (${timePoint?.timePointLabel}) ${timePoint?.repeat === "Repeated" ? `(R${timePoint?.repeatNumber})` : ""}`, "",
                                                `viewEventSchemaFormLists_${site?.siteId}_${subjectId}_${timePoint?.eventId}_${timePoint?.repeatEventId || "repeatEventId"}_${timePoint?.timePointUniqueId}_${timePoint?.repeatTimePointId || "repeatTimePointId"}`,
                                                {
                                                  siteId: site?.siteId,
                                                  subjectId: subjectId,
                                                  schemaId: schemaId,
                                                  siteName: siteName,
                                                  subjectName: subjectName,
                                                  eventName: timePoint?.eventName,
                                                  timePointLabel: timePoint?.timePointLabel,
                                                  type: timePoint?.unscheduledEvent === "Yes" ? "unscheduledForm" : "eventForm",
                                                  viewType: "dataEntry",
                                                  eventId: timePoint?.eventId,
                                                  timePointUniqueId: String(timePoint?.timePointUniqueId),
                                                  repeatEventId: timePoint?.repeatEventId || "",
                                                  repeatTimePointId: String(timePoint?.repeatTimePointId || ""),
                                                })
                                            }
                                          }
                                          }>
                                          {timePoint?.timePointLabel}
                                        </div>
                                        {(!(StudyMode?.startsWith("SDV"))) ?
                                          <div
                                            onClick={() => {
                                              if (timePoint?.repeat === "Yes" && timePoint?.status !== "disabled") {
                                                repeatStudySubjectEvent(site?.siteId, subjectId, schemaId, timePoint?.eventId, timePoint?.timePointUniqueId)
                                              } else {
                                                handleResponse({
                                                  statusCode: 400,
                                                  customMessage: "First unlock this Time Point!"
                                                })
                                              }
                                            }}
                                            className="w-25 text-end" title={timePoint?.repeat === "Repeated" ? `Repeat ${timePoint?.repeatNumber}` : timePoint?.repeat === "Yes" && "Repeat Timepoint"}>
                                            {timePoint?.repeat === "Repeated" ? `R${timePoint?.repeatNumber}` : timePoint?.repeat === "Yes" && <MdRepeatOne style={{ fontSize: 16 }} />}
                                          </div>
                                          :
                                          <div
                                            className="w-25 text-end" title={timePoint?.repeat === "Repeated" && `Repeat ${timePoint?.repeatNumber}`}>
                                            {timePoint?.repeat === "Repeated" && `R${timePoint?.repeatNumber}`}
                                          </div>
                                        }
                                      </div>
                                    </Badge>
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>
                      </Collapse>
                    </div>
                  </div>
                </Collapse>
              </>
            ))}
          </div>
        )}
      </SplitPane>
      <AddNewSubject
        Show={!toggle}
        Hide={setToggle}
        siteId={siteId}
        subjectSettings={subjectSettings}
        Title={`Add New Subject for Site ${siteName}`}
        getStudySiteSubjectList={getStudySiteSubjectList}
      />
      <DeletedSubject
        Show={!toggle1}
        Hide={setToggle1}
        studyId={studyId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        siteId={siteId}
        studyPermission={studyPermission}
        deletedSubjectLoader={deletedSubjectLoader}
        getDeletedStudySubjectRowData={getDeletedStudySubjectRowData}
        subjectDeletedRows={subjectDeletedRows}
        subjectDeletedRowsCount={subjectDeletedRowsCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreStudySubjectRow={softDeleteRestoreStudySubjectRow}
        Title={`Deleted Subject History for Site ${siteName}`}
      />
      <DeletedRepeatEvent
        Show={!toggle19}
        Hide={setToggle19}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        deletedRepeatEventLoader={deletedRepeatEventLoader}
        deletedRepeatEventList={deletedRepeatEventList}
        restoreStudySubjectRepeatEvent={(repeatEvent) => softDeleteRestoreStudySubjectRepeatEvent(activeTabName?.siteId || siteId, activeTabName?.subjectId || subjectId, activeTabName?.schemaId || schemaId, repeatEvent, "restore")}
        Title={`Deleted Repeated Event History of Subject ${subjectName} ${subjectVoid ? "(VOID)" : ""}`}
      />
      <UpdateSubject
        Show={!toggle2}
        Hide={setToggle2}
        getStudySiteSubjectList={getStudySiteSubjectList}
        subjectSettings={subjectSettings}
        subjectId={subjectIdForUpdate}
        setSubjectId={setSubjectIdForUpdate}
        siteId={siteId}
        Title={`Update ${subjectName} ${subjectVoid ? "(VOID)" : ""} Subject for Site ${siteName}`}
      />
      <AssignRandomizationSubject
        Show={!toggle9}
        Hide={setToggle9}
        getStudySiteSubjectList={getStudySiteSubjectList}
        subjectSettings={subjectSettings}
        subjectId={subjectIdForUpdate}
        siteId={siteId}
        schemaId={schemaId}
        Title={`Assign Subject ${subjectName} ${subjectVoid ? "(VOID)" : ""} for Site ${siteName}`}
      />
      <ReassignRandomizationSubject
        Show={!toggle17}
        Hide={setToggle17}
        getStudySiteSubjectList={getStudySiteSubjectList}
        subjectSettings={subjectSettings}
        subjectId={subjectIdForUpdate}
        siteId={siteId}
        schemaId={schemaId}
        Title={`Re-assign Subject ${subjectName} ${subjectVoid ? "(VOID)" : ""} for Site ${siteName}`}
      />
      <ViewSubjectGraph
        Show={!toggle3}
        Hide={setToggle3}
        siteId={siteId}
        Title={`View Subject Graph for Site ${siteName}`}
        getStudySiteSubjectList={getStudySiteSubjectList}
      />
      <ViewSiteHistory
        Show={!toggle18}
        Hide={setToggle18}
        siteId={siteId}
        Title={`View History for Site ${siteName}`}
      />
      <ViewSubjectActivity
        Show={!toggle4}
        Hide={setToggle4}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        subjectId={subjectId}
        Title={`Activity of Subject ${subjectName} ${subjectVoid ? "(VOID)" : ""}`}
      />
      <ViewSubjectHistory
        Show={!toggle5}
        Hide={setToggle5}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        siteId={siteId}
        subjectId={subjectId}
        Title={`History of Subject ${subjectName} ${subjectVoid ? "(VOID)" : ""}`}
      />
      <ViewSubjectDetails
        Show={!toggle6}
        Hide={setToggle6}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        subjectDetails={subjectDetails}
        siteId={siteId}
        subjectId={subjectId}
        Title={`Details of Subject ${subjectDetails?.subjectName} ${subjectDetails?.voidData ? "(VOID)" : ""}`}
      />
      <ViewSiteSubjectGraph
        Show={!toggle7}
        Hide={setToggle7}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        siteId={siteId}
        subjectId={subjectId}
        Title={`Statistics of Subject ${subjectName} ${subjectVoid ? "(VOID)" : ""}`}
      />
      <ViewSubjectMilestone
        Show={!toggle8}
        Hide={setToggle8}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        siteId={siteId}
        subjectId={subjectId}
        Title={`Timeline of Subject ${subjectName} ${subjectVoid ? "(VOID)" : ""}`}
      />
      <MedicalReviewSetting
        Show={!toggle10}
        Hide={setToggle10}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        schemaId={schemaId}
        subjectId={subjectId}
        siteId={siteId}
        Title={`Medical Review of Subject ${subjectName} ${subjectVoid ? "(VOID)" : ""}`}
      />
      <SendForMedicalReview
        Show={!toggle11}
        Hide={setToggle11}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        schemaId={schemaId}
        subjectId={subjectId}
        siteId={siteId}
        Title={`Send For Medical Review of Subject ${subjectName} ${subjectVoid ? "(VOID)" : ""}`}
      />
      <AssignFormSDVReviewer
        Show={!toggle12}
        Hide={setToggle12}
        subjectId={subjectId}
        siteId={siteId}
        setAssignedUser={setAssignedUser}
        assignedUser={assignedUser}
        Title={`Assign Form SDV Reviewer of Subject ${subjectName} ${subjectVoid ? "(VOID)" : ""}`}
      />
      <Eligiblity
        Show={!toggle13}
        Hide={setToggle13}
        Title={`Check eligibility of ${subjectName} Subject`}
        subjectUpdateLoader={subjectUpdateLoader}
        updateStudySubjectScreen={() => updateStudySubjectScreen(subjectId, siteId, "pass")}
      />
      <Discontinue
        Show={!toggle14}
        Hide={setToggle14}
        Title={`Discontinue Subject ${subjectName}`}
        subjectStatusLoader={subjectStatusLoader}
        reason={reason}
        setReason={setReason}
        category={category}
        setCategory={setCategory}
        remark={remark}
        setRemark={setRemark}
        updateStudySubjectStatus={() => updateStudySubjectStatus(subjectId, siteId, "discontinue")}
      />
      <Completion
        Show={!toggle15}
        Hide={setToggle15}
        Title={`Complete Subject ${subjectName}`}
        subjectStatusLoader={subjectStatusLoader}
        completionDate={completionDate}
        setCompletionDate={setCompletionDate}
        updateStudySubjectStatus={() => updateStudySubjectStatus(subjectId, siteId, "completed")}
      />
      <ScreeningFail
        Show={!toggle16}
        Hide={setToggle16}
        Title={`Mark ${subjectName} as failed in screening`}
        subjectUpdateLoader={subjectUpdateLoader}
        reason={reason}
        setReason={setReason}
        updateStudySubjectScreen={() => updateStudySubjectScreen(subjectId, siteId, "fail")}
      />
    </>
  );
};

export default SiteSubjectEventLists;
